/* Sucker Punch mints PDP (new system, 2026-10-03). Picker for sections/sp-pdp-mints.liquid.
   ADD TO CART goes through the theme's <product-form> (same path as the sucker PDPs: fetch /cart/add, PUB_SUB cartUpdate,
   sp-cart.js drawer + protection). HARD RULE (feedback_picker_must_fire_pixels.md): the old mints picker fired
   Meta AddToCart, dataLayer add_to_cart, webPixelsManager product_added_to_cart, TikTok AddToCart and the
   cart:item-added / cart:refresh events by hand, because its raw fetch bypassed the theme form. This page adds through
   the theme form, so Shopify's pixels (Meta AddToCart with the variant id, product_added_to_cart) fire natively ONCE;
   only the dataLayer push, TikTok (if loaded) and the cart events are still sent from here (2026-10-03 QA: no doubles). */
(function () {
  "use strict";
  var root = document.querySelector(".mpdp");
  if (!root) return;
  function $(id) { return document.getElementById(id); }
  function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var PRODUCT_ID = root.getAttribute("data-product-id"), PRODUCT_TITLE = root.getAttribute("data-product-title");
  var chips = all(".chip[data-variant]"), packs = all('input[name="sp-pack"]');
  var bundle = root.querySelector('input[name="sp-pack"][value="3"]');
  var idIn = $("mint-id"), main = $("pgal-img"), stage = $("pgal-stage"), flag = root.querySelector(".gal-flag");
  var btnL = $("pbtn-label"), one = $("mint-one"), three = $("mint-three"), flavorsIn = $("mint-flavors-prop");
  var selects = all("#mint-three select");
  var state = { pack: 1, chip: chips.filter(function (c) { return c.getAttribute("aria-pressed") === "true"; })[0] || chips[0] };

  function showImg(el) {
    if (!el || !main || !el.getAttribute("data-img")) return;
    main.removeAttribute("srcset");
    if (el.getAttribute("data-srcset")) main.setAttribute("srcset", el.getAttribute("data-srcset"));
    main.src = el.getAttribute("data-img");
    if (el.getAttribute("data-alt")) main.alt = el.getAttribute("data-alt");
    all(".pthumb").forEach(function (t) { t.setAttribute("aria-current", "false"); });
    /* hover animation set follows the image shown (sp-mints-hover.js); the 3-Pack uses its data-hover set */
    if (stage) stage.setAttribute("data-mints-hover", el.getAttribute("data-hover") || el.getAttribute("data-name") || "");
  }
  /* a gallery thumbnail is not a flavor hero: no hover animation over it */
  all(".pthumb").forEach(function (t) { t.addEventListener("click", function () { if (stage) stage.setAttribute("data-mints-hover", ""); }); });
  function render(swapImg) {
    var three_ = state.pack === 3 && bundle;
    var src = three_ ? bundle : state.chip;
    chips.forEach(function (c) { c.setAttribute("aria-pressed", c === state.chip ? "true" : "false"); });
    packs.forEach(function (r) { r.checked = (+r.value === state.pack); r.closest(".mpack").classList.toggle("on", r.checked); });
    if (one) one.hidden = !!three_;
    if (three) three.hidden = !three_;
    selects.forEach(function (s) { s.disabled = !three_; });
    if (flavorsIn) { flavorsIn.disabled = !three_; flavorsIn.value = selects.map(function (s) { return s.value; }).join(" · "); }
    if (idIn) idIn.value = src.getAttribute("data-variant");
    var price = src.getAttribute("data-price"), name = three_ ? bundle.getAttribute("data-name") : state.chip.getAttribute("data-name");
    if ($("mint-flavor")) $("mint-flavor").textContent = state.chip.getAttribute("data-name");
    if (btnL && btnL.getAttribute("data-prefix")) btnL.textContent = btnL.getAttribute("data-prefix") + " " + price;
    if (flag) flag.textContent = name;
    if (stage && src.getAttribute("data-ground")) stage.style.setProperty("--gal", src.getAttribute("data-ground"));
    if ($("sbar-price")) $("sbar-price").textContent = price;
    if ($("sbar-plan")) $("sbar-plan").textContent = (root.getAttribute("data-short-title") || "") + " · " + name;
    if (swapImg) showImg(src);
  }
  chips.forEach(function (c) { c.addEventListener("click", function () { state.chip = c; state.pack = 1; render(true); }); });
  packs.forEach(function (r) { r.addEventListener("change", function () { if (r.checked) { state.pack = +r.value; render(true); } }); });
  selects.forEach(function (s) { s.addEventListener("change", function () { render(false); }); });

  /* ?variant=<id>: preselect that flavor (or the 3-Pack) + its image + price */
  var pre = false;
  try {
    var qv = new URLSearchParams(window.location.search).get("variant");
    if (qv) {
      if (bundle && bundle.getAttribute("data-variant") === qv) { state.pack = 3; pre = true; }
      chips.forEach(function (c) { if (c.getAttribute("data-variant") === qv) { state.chip = c; state.pack = 1; pre = true; } });
    }
  } catch (e) {}
  render(pre);

  /* ---- pixels + cart events after a successful add (same calls as the old assets/mints-pdp.js) ---- */
  function fire(it) {
    var value = (it.final_price || it.price || 0) / 100;
    /* Meta: NOT fired by hand any more. The add goes through the theme <product-form>, and Shopify's own Meta pixel
       already sends one AddToCart for it (content_ids = variant id, with an event id for dedup) - the same as the
       sucker PDPs. A second hand-fired event (product id, no event id) double counted. */
    try {
      if (window.dataLayer) window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: { currency: "USD", value: value, items: [{ item_id: it.variant_id || it.id, item_name: it.product_title || PRODUCT_TITLE,
          item_variant: it.variant_title, quantity: it.quantity || 1, price: (it.price || 0) / 100 }] }
      });
    } catch (e) {}
    /* webPixelsManager product_added_to_cart: emitted by Shopify itself for product-form adds; not republished here. */
    try {
      if (window.ttq) window.ttq.track("AddToCart", { content_id: it.variant_id || it.id, content_type: "product",
        content_name: it.product_title || PRODUCT_TITLE, quantity: it.quantity || 1, price: (it.price || 0) / 100, value: value, currency: "USD" });
    } catch (e) {}
  }
  if (typeof window.subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== "product-form" || !ev.cartData) return;
      var d = ev.cartData, items = Array.isArray(d.items) ? d.items : [d];
      items.forEach(fire);
      document.documentElement.dispatchEvent(new CustomEvent("cart:item-added", { detail: { items: items, source: "mints-pdp" }, bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    });
  }
})();
